import styled from 'styled-components'
// themes
import { colors } from 'themes'
// components
import { Paper as PaperOrigin } from 'components/UI'
// utils
import { darken } from 'polished'

const ResourceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`

const ResourceContent = styled.div`
  margin-left: 16px;
  width: 100%;
  overflow: hidden;
`

const ResourceHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 4px;

  > span {
    color: ${colors.blue500};
    cursor: pointer;

    &:hover {
      color: ${darken(0.07, colors.blue500)};
    }
  }
`

const Content = styled.div`
  padding: 16px 0;
  border-bottom: 1px solid ${colors.gray300};
`

const MetadataWrapper = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  overflow: auto;
`

const MetadataContent = styled.div`
  display: flex;
  flex-direction: column;
`

const MetadataLabel = styled.div`
  margin: 8px 0;
  font-size: 12px;
  color: ${colors.gray300};
  line-height: 16px;
  white-space: nowrap;
`

const MetadataValue = styled.div`
  white-space: nowrap;
`

const Paper = styled(PaperOrigin)`
  margin-bottom: 16px;
  padding: 16px;
  position: relative;
  width: 100%;
`

export {
  ResourceWrapper,
  ResourceHeader,
  ResourceContent,
  Content,
  MetadataWrapper,
  MetadataLabel,
  MetadataValue,
  MetadataContent,
  Paper
}
